export function TrustedByHospitals() {
  return (
    <section className="bg-black py-16">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <p className="text-white text-lg font-body leading-relaxed">
          Trusted by leading U.S. hospitals to transport organs around the country in life-saving situations.
        </p>
      </div>
    </section>
  );
}